import { combineReducers } from 'redux';
import { users } from './users.reducer';
import { global } from './global.reducer';

const rootReducer = combineReducers({
	users,
	global
});

export default rootReducer;